<template>
  <div class="not-found-page">
    <div class="content">
      <h1>404</h1>
      <p class="title">{{ t('common.404Title') }}</p>
      <p class="desc">{{ t('common.404Desc') }}</p>
      <button @click="goHome">{{ t('common.backHome') }}</button>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

useHead({
  title: `${t('common.404Title')} - ${t('meta.siteName')}`,
  meta: [
    { name: 'description', content: t('common.404Desc') }
  ]
})

const goHome = () => {
  navigateTo('/')
}
</script>

<style scoped>
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}
.content {
  text-align: center;
  padding: 2rem;
}
h1 {
  font-size: 6rem;
  color: #3da0e8;
  margin: 0;
}
.title {
  font-size: 1.5rem;
  color: #333;
  margin: 1rem 0 0.5rem;
}
.desc {
  color: #666;
  margin-bottom: 2rem;
}
button {
  padding: 0.75rem 2rem;
  color: #fff;
  background: #3da0e8;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background: #2b8fd4;
}
</style>
